module.exports = __webpack_public_path__ + "img/president-john-f.-kennedy.1cf62c38.png";